import React, { useState } from "react";
import SSPCommonModal from "../../CommonComponents/SSPCommonModal/SSPCommonModal";
import { PageBar, SSPCommonButton, } from "../../CommonComponents";
import Grid from "@mui/material/Grid";
import { Box, Card, CardContent, CardHeader, Divider, Typography, TextField, CircularProgress, } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import { post } from "../../services";
import Cookies from "js-cookie";
import styles from "./Styles";
import Loader from "../../CommonComponents/Loader";
const base = "https://";

const AssetMaster = ({ token }) => {
    const id = Cookies.get("ssp_id");
    const [loading, setLoading] = useState(false);
    const [loc, setLoc] = useState("");
    const [modalOpener, setmodalOpener] = useState(false);
    const [message, setmessage] = useState("");
    const [locationCode, setLocationCode] = useState("");


    const handleDownloadAssetMaster = async (type) => {
        setLoading(true);
        let payload = {
            loc: type === "AM" ? (locationCode ? locationCode : "") : (loc ? loc : ""),
            type: type,
            source: "SSP"
        };

        let response = await post(
            base + "bjkhbsrllhuogrxobvufau4rxy0qvvxu.lambda-url.ap-south-1.on.aws/download_data",
            payload,
            true,
            false
        );

        if (response?.status === "success") {
            if (type === "AM") {
                setLocationCode("");
            } else {
                setLoc("");
            }
            window.open(response?.url);
            setLoading(false);
        } else {
            if (type === "AM") {
                setLocationCode("");
            } else {
                setLoc("");
            }
            setmessage(response?.message);
            setmodalOpener(true);
            setLoading(false);
        }
    };

    const handleDownloadCurrentLocation = async (buttonName) => {
        setLoading(true);
        let payload = {
            type: "",
            source: "SSP"
        };
        if (buttonName === 'Download Current Location') {
            payload.type = "PV";
        } else if (buttonName === 'Download Current Location For Asset') {
            payload.type = "AM";
        } else {
            payload.type = "";
        }
        let response = await post(
            base + "bjkhbsrllhuogrxobvufau4rxy0qvvxu.lambda-url.ap-south-1.on.aws/download_data",
            payload,
            true,
            false
        );
        if (response?.status === "success") {
            window.open(response?.url);
            setLoading(false);
        } else {
            setmessage(response?.message);
            setmodalOpener(true);
            setLoading(false);

        }
    }



    const handleChange = (e) => {
        const value = e?.target?.value;
        const numericValue = value?.replace(/[^0-9]/g, '');
        if (numericValue?.length < 10) {
            setLoc(numericValue);
        }
    };
    const handleChangeLocationCode = (e) => {
        const value = e?.target?.value;
        const numericValue = value?.replace(/[^0-9]/g, '');
        if (numericValue?.length < 10) {
            setLocationCode(numericValue);
        }
    };

    return (
        <Box sx={styles.assetMasterContainer} >
            <Loader loading={loading} />
            <PageBar
                text="Asset Management Portal : Asset Master"
            />
            <Card sx={styles.assetmasterCard} >
                <CardHeader
                    p={2}
                    sx={styles.assetmasterCardHeader}
                    title={" Download assets to be tagged (Physical verification) :"}
                    titleTypographyProps={{
                        sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1", },
                    }}
                />
                <Divider />
                <CardContent sx={styles.assetmasterCardContent} >
                    <Grid container spacing={2} >
                        <Grid item xs={12} sm={6} md={6} lg={4} xl={4} sx={styles.locContainer} >
                            <Typography >
                                Enter Location Code:
                            </Typography>
                            <TextField
                                rows={1}
                                variant="outlined"
                                label="Enter Location Code"
                                value={loc}
                                size="small"
                                onChange={handleChange}
                                autoFocus={false}
                                sx={styles.inputStyle}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3.5} xl={4} sx={{ ...styles.dwnldAssetMasterbttnStyle }} >
                            <SSPCommonButton
                                btnText="Download Asset Master"
                                btnFunction={() => {
                                    if (loc?.length > 0) {
                                        handleDownloadAssetMaster('PV')
                                    } else {
                                        setmessage("Please enter location")
                                        setmodalOpener(true);
                                    }
                                }}
                            />

                        </Grid>
                        {/* <Divider orientation="vertical" flexItem /> */}
                        <Box sx={{ width: "2px", backgroundColor: "#3B82F6", marginTop: 3 }} />
                        <Grid item xs={12} sm={5} md={4} lg={3} sx={{ ...styles.dwnldAssetMasterStyle, alignItems: 'flex-end', justifyContent: 'flex-end' }} >
                            <SSPCommonButton
                                btnText={"Download Current Location"}
                                btnFunction={() => handleDownloadCurrentLocation('Download Current Location')}
                            />
                        </Grid>

                    </Grid>
                </CardContent>
                <CardHeader
                    p={2}
                    sx={styles.assetmasterCardHeader}
                    title={" Download Entire Asset Master :"}
                    titleTypographyProps={{
                        sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1", },
                    }}
                />
                <Divider />
                <CardContent sx={styles.assetmasterCardContent} >
                    <Grid container spacing={2} >
                        <Grid item xs={12} sm={6} md={6} lg={4} xl={4} sx={styles.locContainer} >
                            <Typography >
                                Enter Location Code:
                            </Typography>
                            <TextField
                                rows={1}
                                variant="outlined"
                                label="Enter Location Code"
                                value={locationCode}
                                size="small"
                                onChange={handleChangeLocationCode}
                                autoFocus={false}
                                sx={styles.inputStyle}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3.5} xl={4} sx={{ ...styles.dwnldAssetMasterbttnStyle }} >
                            <SSPCommonButton
                                btnText="Download Asset Master"
                                btnFunction={() => {
                                    if (locationCode?.length > 0) {
                                        handleDownloadAssetMaster('AM')
                                    } else {
                                        setmessage("Please enter location")
                                        setmodalOpener(true);
                                    }
                                }}
                            />

                        </Grid>
                        {/* <Divider orientation="vertical" flexItem /> */}
                        <Box sx={{ width: "2px", backgroundColor: "#3B82F6", marginTop: 3 }} />
                        <Grid item xs={12} sm={5} md={4} lg={3} sx={{ ...styles.dwnldAssetMasterStyle, alignItems: 'flex-end', justifyContent: 'flex-end' }} >
                            <SSPCommonButton
                                btnText={"Download Current Location"}
                                btnFunction={() => handleDownloadCurrentLocation('Download Current Location For Asset')}
                            />
                        </Grid>

                    </Grid>

                </CardContent>

            </Card>


            {modalOpener && (
                <SSPCommonModal
                    open={modalOpener}
                    handleOpenClose={setmodalOpener}
                    message={message}
                />
            )}

        </Box>
    )
}

export default AssetMaster


